export default __webpack_public_path__ + "static/media/alphabet-background.a15189aa.jpeg";